import TurfProRobotStatus = ToroEnums.TurfProRobotStatus;
import TurfProRobotType = ToroEnums.TurfProRobotType;

import * as moment from 'moment';
import { ToroEnums } from '../../../common/enumerations/toro.enums';
import TurfProStatusGroup = ToroEnums.TurfProStatusGroup;

export class TurfProRobot {
    public readonly maxScore: number = 20;

    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);

            if (json.lastKnownCoordinates) this.lastKnownCoordinates = new TurfProCoordinates(json.lastKnownCoordinates);
            if (json.lastUpdated) this.lastUpdated = moment.utc(json.lastUpdated).toDate();
            if (json.robotStatus) this.robotStatus = this.toRobotStatus(json.robotStatus);
            if (json.robotType) this.robotType = this.toRobotType(json.robotType);
        }
    }

    batteryPercentage: number;
    lastKnownCoordinates: TurfProCoordinates;
    lastScore: number;
    lastUpdated: Date;
    name: string;
    robotModel: string;
    robotStatus: TurfProRobotStatus;
    robotType: TurfProRobotType;
    serialNumber: string;
    viewLink: string;

    //
    // Computed Properties
    //

    // TODO: This will need to change once we get the real data from TurfPro.
    get statusGroup(): TurfProStatusGroup {
        switch (this.robotStatus) {
            case TurfProRobotStatus.Off:
            case TurfProRobotStatus.OffAfterAlarm:
            case TurfProRobotStatus.Service:
                return TurfProStatusGroup.Off;

            case TurfProRobotStatus.Idle:
            case TurfProRobotStatus.Alarm:
            case TurfProRobotStatus.WaitStation:
            case TurfProRobotStatus.Border:
                return TurfProStatusGroup.Waiting;

            case TurfProRobotStatus.Work:
            case TurfProRobotStatus.GoChargeStation:
            case TurfProRobotStatus.GoUnloadStation:
            case TurfProRobotStatus.LeaveStation:
            case TurfProRobotStatus.GoToPOI:
            case TurfProRobotStatus.Charge:
                return TurfProStatusGroup.Active;
        }

        return TurfProStatusGroup.Unknown;
    }

    //
    // Helper Methods
    //

    toRobotStatus(key: string): TurfProRobotStatus {
        return (TurfProRobotStatus as any)[key] as TurfProRobotStatus | TurfProRobotStatus.Unknown;
    }

    toRobotType(key: string): TurfProRobotType {
        return (TurfProRobotType as any)[key] as TurfProRobotType | TurfProRobotType.Unknown;
    }
}

class TurfProCoordinates {
    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);
        }
    }

    lat: number;
    lng: number;
}

